/**
 * @file experienceDrawer.component.tsx
 * @path apps/website/src/features/experiences/components/experienceDrawer.component.tsx
 */
import { SlidersHorizontal } from "lucide-react";
import {
  Button,
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@sirbastians/ui";
import { ExperienceFilters } from "./experienceFilters.component";

interface ExperienceDrawerProps {
  facade: ReturnType<
    typeof import("../hooks/useExperiencesFacade.hook").useExperiencesFacade
  >;
}

export const ExperienceDrawer = ({ facade }: ExperienceDrawerProps) => {
  const { data, state, actions } = facade;

  return (
    <div className="lg:hidden border-b border-border p-6 md:px-20 flex justify-between items-center">
      <Sheet>
        <SheetTrigger asChild>
          <Button variant="secondary" size="sm" className="gap-2">
            <SlidersHorizontal className="h-4 w-4" /> Filters
          </Button>
        </SheetTrigger>
        <SheetContent
          side="left"
          className="w-[300px] sm:w-[400px] pt-12 bg-card"
        >
          <SheetHeader className="sr-only">
            <SheetTitle>Filter Experiences</SheetTitle>
            <SheetDescription>Search and filter categories.</SheetDescription>
          </SheetHeader>
          <ExperienceFilters
            categories={data.categories}
            activeCategory={state.activeCategory}
            setActiveCategory={actions.setCategory}
            searchQuery={state.searchQuery}
            setSearchQuery={actions.setSearchQuery}
            itemCounts={data.itemCounts}
            maxPrice={state.maxPrice}
            absoluteMaxPrice={data.absoluteMaxPrice}
            priceHistogram={data.priceHistogram} // ✨ NEW
            setMaxPrice={actions.setMaxPrice}
          />
        </SheetContent>
      </Sheet>
      <span className="text-sm font-montserrat font-bold uppercase tracking-widest">
        {data.totalCount} Results
      </span>
    </div>
  );
};
